
<v-autocomplete
    v-if              = "items"
    v-model           = "selected"
    :items            = "items"
    item-value        = "id"
    item-text         = "name"
    :label            = "label"
    :background-color = "background"
    @change           = "onChange"
    auto-select-first
    return-object
    clearable
/>
